import DgForm from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgForm.install = function (Vue) {
  Vue.component(DgForm.name, DgForm)
}
export default DgForm

export { DgForm }